import { Module } from "@/constants";
import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import { AgreementType, AgreementTypeCreate } from "@/types/agreementType";

export const useAgreementTypesDictionary = () => {
  const config = getDictionaryConfig<AgreementType, AgreementTypeCreate>(
    Module.AgreementTypes,
  );
  return config;
};
